import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-simulations',
    templateUrl: './simulations.component.html',
    styleUrls: ['./simulations.component.css'],
    standalone: false
})
export class SimulationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
